<script setup>
import {ref, onBeforeMount} from "vue";
import YTCard from "@/components/YTCard/YTCard.vue";
import router from "@/router/index.js";
import {
  clubStatistics,
  personalCyclingStatistics,
  storeStatistics,
  userStatistics
} from "@/api/statistics/statistics.js";
import { CountTo } from 'vue3-count-to'

onBeforeMount(async() => {
  await handleGetClub()
  await handleGetPersonalCycling()
  await handleGetUserStatistics()
  await handleGetStoreStatistics()
})

// 俱乐部统计数据
const clubData = ref({
  totalCount: 0,
  newLastWeekCount: 0,
  activityTotalCount: 0,
  activityNewLastWeekActivityCount: 0
})
// 约骑统计数据
const personalData = ref({
  totalCount: 0,
  newLastWeekCount: 0
})
// 用户统计数据
const userData = ref({
  totalCount: 0,
  newLastWeekCount: 0
})

// 驿站统计数据
const storeData = ref({
  totalCount: 0,
  newLastWeekCount: 0
})

// 查询俱乐部统计数据
const handleGetClub = async () => {
  clubData.value = await clubStatistics()
}

// 查询约骑统计数据
const handleGetPersonalCycling = async () => {
  personalData.value = await personalCyclingStatistics()
}

// 查询用户统计数据
const handleGetUserStatistics = async () => {
  userData.value = await userStatistics()
}

// 查询驿站统计数据
const handleGetStoreStatistics = async () => {
  storeData.value = await storeStatistics()
}

// 跳转到俱乐部推荐列表
const handle2ClubRecommended = () => {
  router.push("/listClubRecommended")
}

// 跳转到卡券核销列表
const handle2TicketRedemption = () => {
  router.push("/listTicketRedemption")
}
</script>

<template>
  <div class="container_form mg_b_2">
    <YTCard :title="'用户'" :is-show-divider="true">
      <template #container>
        <div class="flex_left">
          <div class="dataBox mg_r_2">
            <countTo
              :title="userData.totalCount"
              class="dataBox_title txt_overflow"
              :startVal="0"
              :endVal="parseInt(userData.totalCount)"
              :duration="3000"
            ></countTo>
            <div class="dataBox_SubTitle">总数</div>
          </div>
          <div class="dataBox">
            <countTo
              :title="userData.newLastWeekCount"
              class="dataBox_title txt_overflow"
              :startVal="0"
              :endVal="parseInt(userData.newLastWeekCount)"
              :duration="3000"
            ></countTo>
            <div class="dataBox_SubTitle">上周新增</div>
          </div>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'俱乐部'" :is-show-divider="true">
      <template #container>
        <div class="flex_left">
          <div class="dataBox mg_r_2">
            <countTo
              :title="clubData.totalCount"
              class="dataBox_title txt_overflow"
              :startVal="0"
              :endVal="parseInt(clubData.totalCount)"
              :duration="3000"
            ></countTo>
            <div class="dataBox_SubTitle">总数</div>
          </div>
          <div class="dataBox mg_r_2">
            <countTo
              :title="clubData.newLastWeekCount"
              class="dataBox_title txt_overflow"
              :startVal="0"
              :endVal="parseInt(clubData.newLastWeekCount)"
              :duration="3000"
            ></countTo>
            <div class="dataBox_SubTitle">上周新增</div>
          </div>
          <div class="dataBox mg_r_2">
            <countTo
                :title="0"
                class="dataBox_title txt_overflow"
                :startVal="0"
                :endVal="parseInt(clubData.activityTotalCount)"
                :duration="3000"
            ></countTo>
            <div class="dataBox_SubTitle">活动总数</div>
          </div>
          <div class="dataBox mg_r_2">
            <countTo
                :title="0"
                class="dataBox_title txt_overflow"
                :startVal="0"
                :endVal="parseInt(clubData.activityNewLastWeekActivityCount)"
                :duration="3000"
            ></countTo>
            <div class="dataBox_SubTitle">上周活动新增</div>
          </div>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'驿站'" :is-show-divider="true">
      <template #container>
        <div class="flex_left">
          <div class="dataBox mg_r_2">
            <countTo
                :title="0"
                class="dataBox_title txt_overflow"
                :startVal="0"
                :endVal="parseInt(storeData.totalCount)"
                :duration="3000"
            ></countTo>
            <div class="dataBox_SubTitle">总数</div>
          </div>
          <div class="dataBox">
            <countTo
                :title="0"
                class="dataBox_title txt_overflow"
                :startVal="0"
                :endVal="parseInt(storeData.newLastWeekCount)"
                :duration="3000"
            ></countTo>
            <div class="dataBox_SubTitle">上周新增</div>
          </div>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'约骑'" :is-show-divider="true">
      <template #container>
        <div class="flex_left">
          <div class="dataBox mg_r_2">
            <countTo
              :title="personalData.totalCount"
              class="dataBox_title txt_overflow"
              :startVal="0"
              :endVal="parseInt(personalData.totalCount)"
              :duration="3000"
            ></countTo>
            <div class="dataBox_SubTitle">总数</div>
          </div>
          <div class="dataBox">
            <countTo
              :title="personalData.newLastWeekCount"
              class="dataBox_title txt_overflow"
              :startVal="0"
              :endVal="parseInt(personalData.newLastWeekCount)"
              :duration="3000"
            ></countTo>
            <div class="dataBox_SubTitle">上周新增</div>
          </div>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'商家'" :is-show-divider="false">
      <template #container>
        <div class="flex_left">
          <div class="dataBox mg_r_2 cursor-pointer" @click="handle2ClubRecommended">
            <span class="dataBox_title txt_overflow">详情</span>
            <div class="dataBox_SubTitle">推荐用户数</div>
          </div>
          <div class="dataBox mg_r_2 cursor-pointer" @click="handle2TicketRedemption">
            <span class="dataBox_title txt_overflow">详情</span>
            <div class="dataBox_SubTitle">卡券核销</div>
          </div>
        </div>
      </template>
    </YTCard>
  </div>
  <div>
    <v-row>
      <v-col>
        <v-btn @click="router.back()">返回</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>
